import type { Content, Strong } from 'mdast'
import * as React from 'react'

import { styled } from '~/styled'

type MarkdownStrongProps = {
  node: Strong
  handleNode: (node: Content) => React.ReactElement<unknown>
}

const StyledMarkdownStrong = styled('strong', {
  base: ['font-semibold']
})

export const MarkdownStrong = ({ node, handleNode }: MarkdownStrongProps) => (
  <StyledMarkdownStrong>{node.children?.map(handleNode)}</StyledMarkdownStrong>
)
